/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */

const onUnbind = (el) => el.__observer?.disconnect();

const onBind = (el, { value = {} }) => {
  // SETUP SETTING
  const settings = {
    effect: value.effect || 'slideup',
    once: value.once || true,
    // using Number.MIN_VALUE as the threshold to avoid strange behaviors with 0 acting differently in different browsers.
    threshold: value.threshold || Number.MIN_VALUE,
    rootMargin: value.margin,
  };

  el.classList.add('scroll-reveal', settings.effect);

  el.__observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        el.classList.add('animated');

        if (settings.once) {
          el.__observer.disconnect();
        }
      } else {
        el.classList.remove('animated');
      }
    });
  }, settings);
  el.__observer.observe(el);
};

export default {
  beforeMount: onBind,
  componentUpdated: onBind,
  unmounted: onUnbind,
};
